// src/utils/audioManager.js - Updated: 2026-02-14 13:12
const audio = {
    backgroundMusic: null,
    audioCtx: null,
    isMuted: true,

    // Separate Volumes
    musicVolume: 0.4,
    sfxVolume: 0.6,

    currentFileName: null,
    musicMode: 'default', // 'default' | 'custom'
    customTrack: null, // Selected custom track filename
    isShuffle: false,
    _uiUpdateInterval: null,

    // Music List for Settings
    musicList: [
        { name: "Gaddar Bilgi Sizlerle", file: "gaddar_bilgi_sizlerle.mp3", category: 'general' },
        { name: "Dediler Yapamazlar", file: "dediler_yapamazlar.mp3", category: 'general' },
        { name: "Gaddar Yerli Milli", file: "yerli_milli.mp3", category: 'general' },
        { name: "Gaddarın Peşindeyim", file: "gaddarin_pesindeyim.mp3", category: 'general' },
        { name: "Tımarhane", file: "timarhane.mp3", category: 'general' },
        { name: "Gaddar Halay", file: "gaddar_halay.mp3", category: 'general' },
        { name: "Çalkala Ayranı", file: "calkala_ayrani.mp3", category: 'general' },
        { name: "Gaddar Bilgi Geliyor", file: "gaddar_bilgi_geliyor.mp3", category: 'general' },
        { name: "Yaşlısı Genci", file: "yaslisi_genci.mp3", category: 'general' },
        { name: "80 80 160 Gaddarbilgi", file: "80_80_160_gaddarbilgi.mp3", category: 'general' },
        { name: "Gaddar ile Coğrafya", file: "gaddar_ile_cografya.mp3", category: 'general' },
        { name: "Gaddar ile Psikoloji", file: "gaddar_soru_3.mp3", category: 'general' },
        { name: "Sen yoksan Gaddarbilgi", file: "sen_yoksan_gaddarbilgi.mp3", category: 'general' },
        { name: "sen yoksan arabesk", file: "sen_yoksan_arabesk.mp3", category: 'general' },
        { name: "Gaddarbilgi Ramazan Özel", file: "gaddar_ramazan_ozel.mp3", category: 'general' },
        { name: "Gaddarbilgi İlahi", file: "gaddarbilgi_ilahi.mp3", category: 'general' },
        { name: "senin ilacın belli", file: "senin_ilacin_belli.mp3", category: 'general' },
        { name: "Gaddarbilgi'nin ruhuna", file: "gaddarbilginin_ruhuna.mp3", category: 'general' },
        { name: "gaddarbilgi yanında", file: "gaddarbilgi_yaninda.mp3", category: 'general' },
        { name: "gaddarbilgi zirvede", file: "gaddarbilgi_zirvede.mp3", category: 'general' },
        { name: "gaddarbilgi gümbür gümbür", file: "gaddarbilgi_gumbur_gumbur.mp3", category: 'general' },
        { name: "oynuyoruz gaddarbilgi", file: "oyuyoruz_gaddarbilgi.mp3", category: 'general' },
        { name: "doğru bildin evlat", file: "dogru_bildin_evlat.mp3", category: 'general' },
        { name: "gaddarbilgi hoş geldin.", file: "gaddarbilgi_hos_geldin.mp3", category: 'general' },
        { name: "gaddarbilgi ortalığı salladı", file: "gaddarbilgi_ortaligi_salladi.mp3", category: 'general' },
        { name: "Başımda Gaddarbilgi", file: "basimda_gaddarbilgi.mp3", category: 'general' },
        // Padişah Besteleri
        { name: "Gondol - Sultan Abdülaziz", file: "gondol_sultan_abdulaziz.mp3", category: 'sultan' },
        { name: "5. Murad Bestesi", file: "besinci_murad.mp3", category: 'sultan' }
    ],

    init: function () {
        this.backgroundMusic = new Audio();
        this.backgroundMusic.loop = false; // We handle looping manually for next track
        this.backgroundMusic.volume = this.musicVolume;

        // Add event listeners for new features
        this.backgroundMusic.addEventListener('ended', () => {
            if (this.musicMode === 'default') {
                this.playNext(); // sequential or shuffle
            } else if (this.musicMode === 'custom' && this.customTrack) {
                this.backgroundMusic.play().catch(e => console.warn("Replay failed", e)); // Loop single custom track
            }
        });

        this.backgroundMusic.addEventListener('timeupdate', () => {
            this._updateProgressUI();
        });

        // Load saved preferences
        try {
            const savedMode = localStorage.getItem('gaddar_music_mode');
            if (savedMode) this.musicMode = savedMode;

            const savedTrack = localStorage.getItem('gaddar_custom_track');
            if (savedTrack) this.customTrack = savedTrack;

            const savedMute = localStorage.getItem('gaddar_is_muted');
            if (savedMute !== null) {
                this.isMuted = (savedMute === 'true');
            } else {
                this.isMuted = true; // Default to true if not set
            }

            const savedMusicVol = localStorage.getItem('gaddar_music_volume');
            if (savedMusicVol !== null) this.musicVolume = parseFloat(savedMusicVol);

            const savedSFXVol = localStorage.getItem('gaddar_sfx_volume');
            if (savedSFXVol !== null) this.sfxVolume = parseFloat(savedSFXVol);

            this.backgroundMusic.volume = this.musicVolume;
        } catch (e) { console.warn("Storage access failed", e); }

        // FORCE MUTE ON LAUNCH (User request: Always start off)
        this.isMuted = true;
        localStorage.setItem('gaddar_is_muted', 'true');

        // Set a default track so Play button works immediately
        if (!this.currentFileName) {
            this.currentFileName = 'gaddar_bilgi_sizlerle.mp3';
            this.backgroundMusic.src = '/assets/music/gaddar_bilgi_sizlerle.mp3';
        }

        // Init AudioContext
        this.audioCtx = null;
    },

    getAudioCtx: function () {
        if (!this.audioCtx) {
            this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        }
        if (this.audioCtx.state === 'suspended') {
            this.audioCtx.resume();
        }
        return this.audioCtx;
    },

    unlockAudio: function () {
        if (this.isMuted) return;
        const ctx = this.getAudioCtx();
        if (this.backgroundMusic && this.backgroundMusic.paused && this.backgroundMusic.src) {
            this.backgroundMusic.play().catch(() => { });
        }
    },

    // Main Play Function
    playMusic: function (fileName, loop = true) {
        if (!fileName) return;

        // Custom Mode Logic
        if (this.musicMode === 'custom' && this.customTrack) {
            if (fileName !== this.customTrack) {
                if (this.currentFileName !== this.customTrack) {
                    this._forcePlay(this.customTrack, true);
                }
                return;
            }
        }

        this._forcePlay(fileName, loop);
    },

    // Internal helper to actually enforce playing a file
    _forcePlay: function (fileName, loop) {
        let path = fileName;
        if (!fileName.includes('/')) {
            // Use absolute path for public directory assets
            path = `/assets/music/${fileName}`;
        }

        if (this.currentFileName === fileName) {
            if (this.backgroundMusic.paused && !this.isMuted) {
                this.backgroundMusic.play().catch(e => console.log("Müzik çalınamadı:", e));
            }
            return;
        }

        this.backgroundMusic.src = path;
        this.currentFileName = fileName;
        // loop is handled manually by 'ended' listener unless it's custom track
        this.backgroundMusic.loop = (this.musicMode === 'custom');

        if (!this.isMuted) {
            this.backgroundMusic.play().then(() => {
                this._updatePlayButtonUI(true);
                // Also update mute button UI if it was showing muted
                if (window.MusicWidget && window.MusicWidget.syncUI) window.MusicWidget.syncUI();
            }).catch(e => {
                console.warn(`Müzik çalınamadı: ${path}`, e);
            });
        }

        // Update Title UI
        const nameDisplay = document.getElementById('music-current-track');
        if (nameDisplay) {
            const trackInfo = this.musicList.find(t => t.file === fileName);
            nameDisplay.innerText = trackInfo ? trackInfo.name : fileName;
        }
    },

    setMusicMode: function (mode, trackName = null) {
        this.musicMode = mode;
        localStorage.setItem('gaddar_music_mode', mode);

        if (mode === 'custom') {
            if (trackName) {
                // Sanitize trackName if it comes from old storage with spaces
                if (trackName === "80 80 160 gaddarbilgi.mp3") trackName = "80_80_160_gaddarbilgi.mp3";

                this.customTrack = trackName;
                localStorage.setItem('gaddar_custom_track', trackName);
            }
            if (this.customTrack) {
                this._forcePlay(this.customTrack, true);
            }
        } else {
            // Revert to default logic
            this._forcePlay('gaddarbilgi_hos_geldin.mp3', true);
        }
    },

    stopMusic: function () {
        if (this.backgroundMusic) {
            this.backgroundMusic.pause();
            this.backgroundMusic.currentTime = 0;
            this.backgroundMusic.src = '';
            this.currentFileName = null;
            this._updatePlayButtonUI(false);

            const nameDisplay = document.getElementById('music-current-track');
            if (nameDisplay) nameDisplay.innerText = "Parça Seçilmedi";
        }
    },

    // --- NEW: Player Controls ---

    togglePlayPause: function () {
        if (!this.backgroundMusic || !this.currentFileName) return;

        if (this.backgroundMusic.paused) {
            this.setMute(false); // Unmute when playing manually
            this.backgroundMusic.play().then(() => {
                this._updatePlayButtonUI(true);
                if (window.MusicWidget && window.MusicWidget.syncUI) window.MusicWidget.syncUI();
            }).catch(e => console.warn(e));
        } else {
            this.backgroundMusic.pause();
            this._updatePlayButtonUI(false);
        }
    },

    playNext: function () {
        if (this.musicList.length === 0) return;

        let nextTrack = null;
        if (this.isShuffle) {
            // Pick random track not matching current
            let available = this.musicList.filter(t => t.file !== this.currentFileName);
            if (available.length === 0) available = this.musicList; // fallback
            nextTrack = available[Math.floor(Math.random() * available.length)];
        } else {
            // Find current index
            const idx = this.musicList.findIndex(t => t.file === this.currentFileName);
            let nextIdx = idx + 1;
            if (nextIdx >= this.musicList.length) nextIdx = 0; // wrap around
            nextTrack = this.musicList[nextIdx];
        }

        if (nextTrack) {
            this._forcePlay(nextTrack.file, false);
        }
    },

    toggleShuffle: function () {
        this.isShuffle = !this.isShuffle;
        const btn = document.getElementById('music-shuffle-btn');
        if (btn) {
            if (this.isShuffle) {
                btn.style.color = "var(--accent-gold)";
            } else {
                btn.style.color = "";
            }
        }
        return this.isShuffle;
    },

    seek: function (progressPercent) {
        if (!this.backgroundMusic || !this.backgroundMusic.duration) return;
        const newTime = (progressPercent / 100) * this.backgroundMusic.duration;
        this.backgroundMusic.currentTime = newTime;
    },

    _updatePlayButtonUI: function (isPlaying) {
        const icon = document.getElementById('music-play-icon');
        if (icon) {
            icon.innerText = isPlaying ? "⏸" : "▶";
        }
    },

    _updateProgressUI: function () {
        if (!this.backgroundMusic) return;

        const currentTimeEl = document.getElementById('music-current-time');
        const totalTimeEl = document.getElementById('music-total-time');
        const slider = document.getElementById('music-progress-slider');

        if (slider && currentTimeEl && totalTimeEl) {
            if (isNaN(this.backgroundMusic.duration)) return;

            const current = this.backgroundMusic.currentTime;
            const duration = this.backgroundMusic.duration;

            slider.value = (current / duration) * 100;
            if (window.updateSliderProgress) {
                window.updateSliderProgress(slider);
            }

            const formatTime = (time) => {
                const mins = Math.floor(time / 60);
                const secs = Math.floor(time % 60);
                return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
            };

            currentTimeEl.innerText = formatTime(current);
            totalTimeEl.innerText = formatTime(duration);
        }
    },
    // ----------------------------

    setMusicVolume: function (val) {
        this.musicVolume = val;
        localStorage.setItem('gaddar_music_volume', val);
        if (this.backgroundMusic) {
            this.backgroundMusic.volume = val;
        }
    },

    setSFXVolume: function (val) {
        this.sfxVolume = val;
        localStorage.setItem('gaddar_sfx_volume', val);
    },

    setMute: function (shouldBeMuted) {
        this.isMuted = shouldBeMuted;
        localStorage.setItem('gaddar_is_muted', shouldBeMuted);

        if (this.isMuted) {
            if (this.backgroundMusic) this.backgroundMusic.pause();
        } else {
            // Ensure context is running
            if (this.audioCtx && this.audioCtx.state === 'suspended') {
                this.audioCtx.resume();
            }
            if (this.backgroundMusic && this.backgroundMusic.src) {
                this.backgroundMusic.volume = this.musicVolume;
                this.backgroundMusic.play().catch(e => console.log("Müzik çalınamadı:", e));
            } else {
                // Fallback if src is missing/cleared
                if (this.musicMode === 'custom' && this.customTrack) this._forcePlay(this.customTrack, true);
                else this._forcePlay('gaddarbilgi_hos_geldin.mp3', true);
            }
        }
        return this.isMuted;
    },

    toggleMute: function () {
        return this.setMute(!this.isMuted);
    },

    playSound: function (soundName) {
        if (this.sfxVolume <= 0) return; // Mute kontrolü

        let fileName = '';

        switch (soundName) {
            case 'correct': fileName = 'dogru.mp3'; break;
            case 'wrong': fileName = 'yanlis.mp3'; break;
            case 'toggle_on': fileName = 'ayarlar_buton_acik.mp3'; break;
            case 'toggle_off': fileName = 'ayarlar_buton_kapali.mp3'; break;
            case 'time_up': fileName = 'sürebitti.mp3'; break;
            case 'timer_selected': fileName = 'sayaç süre.mp3'; break;
            case 'game_over_online': fileName = 'cehalet kulesi yenilgi.mp3'; break;
            case 'success': fileName = 'bimbom.mp3'; break;
            case 'infaz': fileName = 'infazet.mp3'; break;
            case 'affet': fileName = 'kefen.mp3'; break;
            case 'continue': fileName = 'devamet.wav'; break;
            case 'back': fileName = 'geridon.wav'; break;
            case 'categories': fileName = 'kategoriler.wav'; break;
            case 'gun_hand': fileName = 'gun_handing.mp3'; break;
            case 'buttons': fileName = 'butonlar.wav'; break;
            case 'lobby_entry': fileName = 'online_bekleme.wav'; break;
            case 'history_today': fileName = 'gununtarih.wav'; break;
            case 'ready_go': fileName = 'com_go.wav'; break;
            case 'hover_mode': fileName = 'Empty.wav'; break;
        }

        if (fileName) {
            const path = new URL(`../assets/SFX/${fileName}`, import.meta.url).href;
            const sfx = new Audio(path);
            sfx.volume = this.sfxVolume;
            sfx.play().catch(() => { });
        }
    },

    playSFX: function (fileName) {
        if (this.sfxVolume <= 0) return;
        // Vite-compatible asset loading
        const getAssetUrl = (path) => new URL(path, import.meta.url).href;
        let path = '';
        if (fileName.includes('/')) {
            path = fileName;
        } else {
            // We need to be careful with dynamic templates in Vite
            // Best to rely on specific imports if possible, but for dynamic files:
            path = new URL(`../assets/SFX/${fileName}`, import.meta.url).href;
        }

        const sfx = new Audio(path);
        sfx.volume = this.sfxVolume;
        sfx.play().catch(e => console.warn("SFX play failed", e));
    }
};

// Init
audio.init();
window.audio = audio;
